// Your own tags (roadmap #33) and reviews (#34) — the pure helpers.

export const REVIEW_MAX_LENGTH = 10000;
export const TAGS_MAX = 20;

// "  Rainy  Day! " → "rainy day". Lower-case, single spaces, no leading "#",
// letters / digits / spaces / - and & only, at most 32 characters.
export function normalizeTag(raw) {
	const t = String(raw ?? "")
		.normalize("NFKC")
		.toLowerCase()
		.replace(/^#+/, "")
		.replace(/[^\p{L}\p{N}\s&-]/gu, "")
		.replace(/\s+/g, " ")
		.trim()
		.slice(0, 32)
		.trim();
	return t || null;
}

export function addTag(tags, tag) {
	const t = normalizeTag(tag);
	if (!t || (tags ?? []).includes(t)) return [...(tags ?? [])];
	return [...(tags ?? []), t].slice(0, TAGS_MAX);
}

export function removeTag(tags, tag) {
	return (tags ?? []).filter((t) => t !== tag);
}

// Every tag in use, most used first (suggestions + the list filter's options).
export function allTags(items) {
	const counts = new Map();
	for (const it of items ?? []) for (const t of it.tags ?? []) counts.set(t, (counts.get(t) ?? 0) + 1);
	return [...counts.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).map(([t]) => t);
}
